import { LocationQueryEnum, ILocationQueryLabel } from "redmond";
import { delay, put } from "redux-saga/effects";
import { fetchLocationAutocomplete } from "../../../api/v0/search/fetchLocationAutocomplete";
import Logger from "../../../helpers/Logger";
import { actions } from "../actions";

export function* fetchDestinationCategories(
  action: actions.IFetchDestinationCategories
) {
  yield delay(300);
  try {
    const requestBody: ILocationQueryLabel = {
      LocationQuery: LocationQueryEnum.Label,
      l: action.queryString,
    };
    const { categories } = yield fetchLocationAutocomplete(requestBody);

    yield put(actions.setDestinationCategories(categories));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setDestinationCategories([]));
    yield put(actions.setDestinationAutocompleteError(true));
  }
}
